@if (toast) {
  <div class="toast" [class]="toast.type">
    <div class="toast__iconbox">
      <mat-icon size-medium>{{ getIcon(toast.type) }}</mat-icon>
    </div>
    <div class="toast__message">{{ toast.message }}</div>
  </div>
}
